var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagedark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33474 1.36704C8.42769 1.29439 9.57008 1.29424 10.6653 1.36704C14.0902 1.59471 16.8077 4.35943 17.0311 7.81676C17.073 8.46357 17.073 9.13262 17.0311 9.77943C16.8077 13.2368 14.0902 16.0015 10.6653 16.2292C9.57008 16.302 8.42769 16.3018 7.33474 16.2292C6.91104 16.201 6.44983 16.1008 6.04379 15.9336C5.86523 15.86 5.74401 15.8103 5.65531 15.7778C5.59432 15.8197 5.51331 15.8792 5.39535 15.9662C4.80102 16.4045 4.05069 16.7119 2.98588 16.686L2.95158 16.6851C2.74616 16.6802 2.52721 16.675 2.34864 16.6405C2.13356 16.5988 1.86747 16.4948 1.70093 16.2109C1.51967 15.9019 1.59235 15.5894 1.66266 15.3925C1.72902 15.2068 1.84405 14.9889 1.96157 14.7664L1.97768 14.7358C2.32743 14.0731 2.42485 13.5315 2.23785 13.1703C1.61361 12.228 1.05204 11.0667 0.968851 9.77943C0.92705 9.13262 0.92705 8.46358 0.968851 7.81677C1.19229 4.35943 3.90975 1.59471 7.33474 1.36704ZM5.8125 7.125C5.8125 7.43566 6.06434 7.6875 6.375 7.6875H9C9.31066 7.6875 9.5625 7.43566 9.5625 7.125C9.5625 6.81434 9.31066 6.5625 9 6.5625H6.375C6.06434 6.5625 5.8125 6.81434 5.8125 7.125ZM5.8125 10.875C5.8125 11.1857 6.06434 11.4375 6.375 11.4375H11.625C11.9357 11.4375 12.1875 11.1857 12.1875 10.875C12.1875 10.5643 11.9357 10.3125 11.625 10.3125H6.375C6.06434 10.3125 5.8125 10.5643 5.8125 10.875Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagedark);
export default __webpack_public_path__ + "static/media/messagedark.19d5d88ab5347c175ac8b9bfdca3f68e.svg";
export { ForwardRef as ReactComponent };